import { Fragment } from "react";
import { Row, Col } from "./Flexbox";
import Text from "./Text";
import { Input, fieldRow, useRatioFieldRow } from "./FormField";
import { useFieldArray, useWatch } from "react-hook-form";

const SubstratumAndInk = ({theme, control}) => {

    const format = useWatch({control, name: "format"}); //Get the value of the format parameter
    //Flexo adds a third field to the substrate row, so it carries its own ratio
    const substrateRow = useRatioFieldRow(...(format === "Flexo" ? [8, 1, 1] : [8, 1]));

    const {fields, append, remove} = useFieldArray({control, name: 'substrates'});
    const addSubstrate = () => {
        if (fields.length < 3) {    //Render a maximum of three substrates
            const newEntry = format === "Flexo"
                ? {substrate: "", grammage: "", rollWidth: ""}
                : {substrate: "", grammage: ""}
            append(newEntry);
        }
    }

    return (
        <Col style={{width: '100%', alignItems: 'start', marginTop: 64}}>
            <Text size={15} color={theme.Black} weight={"extrabold"}>Sustrato y tintas</Text>
            <Col style={{width: '100%', justifyContent: 'space-between'}}>
                {fields.map((field, index) => (
                    <Fragment key={field.id}>
                        <Row style={{...substrateRow, width: '100%', marginTop: 16}}>
                            <Input theme={theme} control={control} name={`substrates.${index}.substrate`} label="Sustrato"/>
                            <Input theme={theme} control={control} name={`substrates.${index}.grammage`} label="Gramaje" suffix="g/m2"/>
                            {format === "Flexo" && (
                                <Input theme={theme} control={control} name={`substrates.${index}.rollWidth`} label="Ancho bobina"/>
                            )}
                        </Row>
                            <Row style={{width: '100%', justifyContent: 'space-between', marginTop: 16}}>
                            {fields.length < 3 && (
                                <Text size={15} style={{ cursor:'pointer', transition:'transform 2s ease'}}  color={theme.Magenta} onClick={addSubstrate}>Añadir sustrato</Text>
                            )}
                            {fields.length > 1 && (
                                <Text size={15} style={{ cursor:'pointer', transition:'transform 2s ease'}}  color={theme.Magenta} onClick={() => remove(index)}>Eliminar sustrato</Text>
                            )}
                        </Row>
                    </Fragment>
                ))}
                <Row style={{...fieldRow, width: '100%', marginTop: 16}}>
                    <Input theme={theme} control={control} name="frontInk" label="Tintas frente"/>
                    <Input theme={theme} control={control} name="backInk" label="Tintas vuelta"/>
                </Row>
                {format !== "Caja" && (
                    <Row style={{...fieldRow, width: '100%', marginTop: 16}}>
                        <Input theme={theme} control={control} name="pages" label="Páginas"/>
                        <Input theme={theme} control={control} name="frontPage" label="Portada"/>
                        <Input theme={theme} control={control} name="interior" label="Interior"/>
                    </Row>
                )}
            </Col>
        </Col>
    )

}

export default SubstratumAndInk;